import React from "react";
import { useTranslation } from "react-i18next";

const FlightTimes = () => {
  const { t } = useTranslation();

  return (
    <div className="list-trip">
      <h4>{t("flightTimes")}</h4>
      <div className="nav-tabs-box">
        <nav>
          <div className="nav nav-tabs" id="nav-tab" role="tablist">
            <button
              className="nav-link active"
              id="nav-home-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-home"
              type="button"
              role="tab"
              aria-controls="nav-home"
              aria-selected="true"
            >
              {t("departingFlight")}
            </button>
            <button
              className="nav-link"
              id="nav-profile-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-profile"
              type="button"
              role="tab"
              aria-controls="nav-profile"
              aria-selected="false"
            >
              {t("returnFlight")}
            </button>
          </div>
        </nav>

        <div className="tab-content" id="nav-tabContent">
          {/* Departing Flights */}
          <div
            className="tab-pane fade show active"
            id="nav-home"
            role="tabpanel"
            aria-labelledby="nav-home-tab"
            tabIndex="0"
          >
            <p>{t("departsMumbai")}</p>
            <ul className="list-unstyled p-0 m-0">
              <li>
                <div className="form-check d-flex align-items-baseline justify-content-between gap-3">
                  <div className="radioBox">
                    <input className="form-check-input" type="checkbox" id="depart1" />
                    <label className="form-check-label" htmlFor="depart1">
                      {t("time1")}
                    </label>
                  </div>
                  <div className="d-flex align-items-center text-right-box">312</div>
                </div>
              </li>
              <li>
                <div className="form-check d-flex align-items-baseline justify-content-between gap-3">
                  <div className="radioBox">
                    <input className="form-check-input" type="checkbox" id="depart2" />
                    <label className="form-check-label" htmlFor="depart2">
                      {t("time2")}
                    </label>
                  </div>
                  <div className="d-flex align-items-center text-right-box">216</div>
                </div>
              </li>
              <li>
                <div className="form-check d-flex align-items-baseline justify-content-between gap-3">
                  <div className="radioBox">
                    <input className="form-check-input" type="checkbox" id="depart3" />
                    <label className="form-check-label" htmlFor="depart3">
                      {t("time3")}
                    </label>
                  </div>
                  <div className="d-flex align-items-center text-right-box">30</div>
                </div>
              </li>
              <li>
                <div className="form-check d-flex align-items-baseline justify-content-between gap-3">
                  <div className="radioBox">
                    <input className="form-check-input" type="checkbox" id="depart4" />
                    <label className="form-check-label" htmlFor="depart4">
                      {t("time4")}
                    </label>
                  </div>
                  <div className="d-flex align-items-center text-right-box">63</div>
                </div>
              </li>
            </ul>

            <p>{t("arrivesLondon")}</p>
            <ul className="list-unstyled p-0 m-0">
              <li>
                <div className="form-check d-flex align-items-baseline justify-content-between gap-3">
                  <div className="radioBox">
                    <input className="form-check-input" type="checkbox" id="arrive1" />
                    <label className="form-check-label" htmlFor="arrive1">
                      {t("time1")}
                    </label>
                  </div>
                  <div className="d-flex align-items-center text-right-box">312</div>
                </div>
              </li>
              <li>
                <div className="form-check d-flex align-items-baseline justify-content-between gap-3">
                  <div className="radioBox">
                    <input className="form-check-input" type="checkbox" id="arrive2" />
                    <label className="form-check-label" htmlFor="arrive2">
                      {t("time2")}
                    </label>
                  </div>
                  <div className="d-flex align-items-center text-right-box">216</div>
                </div>
              </li>
              <li>
                <div className="form-check d-flex align-items-baseline justify-content-between gap-3">
                  <div className="radioBox">
                    <input className="form-check-input" type="checkbox" id="arrive3" />
                    <label className="form-check-label" htmlFor="arrive3">
                      {t("time3")}
                    </label>
                  </div>
                  <div className="d-flex align-items-center text-right-box">30</div>
                </div>
              </li>
              <li>
                <div className="form-check d-flex align-items-baseline justify-content-between gap-3">
                  <div className="radioBox">
                    <input className="form-check-input" type="checkbox" id="arrive4" />
                    <label className="form-check-label" htmlFor="arrive4">
                      {t("time4")}
                    </label>
                  </div>
                  <div className="d-flex align-items-center text-right-box">63</div>
                </div>
              </li>
            </ul>
          </div>

          {/* Return Flights */}
          <div
            className="tab-pane fade"
            id="nav-profile"
            role="tabpanel"
            aria-labelledby="nav-profile-tab"
            tabIndex="0"
          >
            <p>{t("departsMumbai")}</p>
            <ul className="list-unstyled p-0 m-0">
              <li>
                <div className="form-check d-flex align-items-baseline justify-content-between gap-3">
                  <div className="radioBox">
                    <input className="form-check-input" type="checkbox" id="departR1" />
                    <label className="form-check-label" htmlFor="departR1">
                      {t("time1")}
                    </label>
                  </div>
                  <div className="d-flex align-items-center text-right-box">312</div>
                </div>
              </li>
              <li>
                <div className="form-check d-flex align-items-baseline justify-content-between gap-3">
                  <div className="radioBox">
                    <input className="form-check-input" type="checkbox" id="departR2" />
                    <label className="form-check-label" htmlFor="departR2">
                      {t("time2")}
                    </label>
                  </div>
                  <div className="d-flex align-items-center text-right-box">216</div>
                </div>
              </li>
            </ul>

            <p>{t("arrivesLondon")}</p>
            <ul className="list-unstyled p-0 m-0">
              <li>
                <div className="form-check d-flex align-items-baseline justify-content-between gap-3">
                  <div className="radioBox">
                    <input className="form-check-input" type="checkbox" id="arriveR1" />
                    <label className="form-check-label" htmlFor="arriveR1">
                      {t("time3")}
                    </label>
                  </div>
                  <div className="d-flex align-items-center text-right-box">30</div>
                </div>
              </li>
              <li>
                <div className="form-check d-flex align-items-baseline justify-content-between gap-3">
                  <div className="radioBox">
                    <input className="form-check-input" type="checkbox" id="arriveR2" />
                    <label className="form-check-label" htmlFor="arriveR2">
                      {t("time4")}
                    </label>
                  </div>
                  <div className="d-flex align-items-center text-right-box">63</div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FlightTimes;
